// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Application Form Styles
 * Clean, responsive styles matching UserCreateModal layout
 */

/* Modal Overlay - Now using global styles from design-system.css */

/* Modal Container - Now using global styles from design-system.css */

/* Modal Header - Now using global styles from design-system.css */

/* Close button - Now using global .modal-close styles from design-system.css */

/* Modal Body - Now using global styles from design-system.css */

/* Form Sections - Now using global styles from design-system.css */

/* Committee Member Sections */
.committee-member {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 1.5rem;
  border: 1px solid #e9ecef;
}

.committee-member:last-child {
  margin-bottom: 0;
}

.committee-member h5 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
}

/* Form Rows */
.form-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 16px;
}

.form-row:last-child {
  margin-bottom: 0;
}

/* Form Groups */
/* Form Groups - Now using global styles from design-system.css */

.form-group input.error,
.form-group select.error,
.form-group textarea.error {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}

.form-group input:disabled,
.form-group select:disabled,
.form-group textarea:disabled {
  background: #f8f9fa;
  color: #6c757d;
  cursor: not-allowed;
}

/* Select Styling */
.form-group select {
  cursor: pointer;
}

/* Field Descriptions */
.field-description {
  color: #6c757d;
  font-size: 0.875rem;
  margin: 0.5rem 0 1rem 0;
  line-height: 1.5;
}

.section-description {
  color: #6c757d;
  font-size: 0.9rem;
  margin: 0 0 1rem 0;
  line-height: 1.6;
}

/* Full Width Form Groups */
.form-group.full-width {
  grid-column: 1 / -1;
}

/* Screening Formats */
.screening-formats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}

.format-option {
  background: white;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.format-option:hover {
  border-color: #0D3B66;
  box-shadow: 0 2px 4px rgba(13, 59, 102, 0.1);
}

.format-checkbox-label {
  display: block;
  cursor: pointer;
  padding: 1rem;
  margin: 0;
}

.format-checkbox-label input[type="checkbox"] {
  display: none;
}

.format-checkbox-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.format-checkbox-label input[type="checkbox"]:checked+.format-checkbox-content {
  background: rgba(13, 59, 102, 0.05);
}

.format-icon {
  font-size: 1.25rem;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  border-radius: 50%;
  flex-shrink: 0;
}

.format-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1;
}

.format-name {
  font-weight: 600;
  color: #333;
  font-size: 0.9rem;
}

.format-description {
  color: #6c757d;
  font-size: 0.8rem;
  line-height: 1.4;
}

/* Settings Grid */
.settings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
  margin-top: 1rem;
}

.setting-group {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1.5rem;
  border: 1px solid #e9ecef;
}

.setting-group h5 {
  margin: 0 0 1rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid #e9ecef;
}

.setting-option {
  margin-bottom: 1rem;
}

.setting-option:last-child {
  margin-bottom: 0;
}

.setting-checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.75rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  background: white;
  border: 1px solid #e9ecef;
}

.setting-checkbox-label:hover {
  background: #f8f9fa;
  border-color: #0D3B66;
}

.setting-checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #0D3B66;
  cursor: pointer;
  margin-top: 0.25rem;
  flex-shrink: 0;
}

.setting-content {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1 1;
}

.setting-title {
  font-weight: 600;
  color: #333;
  font-size: 0.9rem;
}

.setting-description {
  color: #6c757d;
  font-size: 0.8rem;
  line-height: 1.4;
}

.setting-checkbox-label.required {
  border-color: #0D3B66;
  background: rgba(13, 59, 102, 0.05);
}

.terms-group {
  grid-column: 1 / -1;
  background: rgba(0, 123, 255, 0.05);
  border: 2px solid rgba(0, 123, 255, 0.2);
}

/* Checkbox Groups */
.checkbox-group {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  margin-top: 0.5rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  padding: 0.75rem;
  border-radius: 6px;
  transition: all 0.2s ease;
  background: white;
  border: 1px solid #e9ecef;
}

.checkbox-label:hover {
  background: #f8f9fa;
  border-color: #0D3B66;
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #0D3B66;
  cursor: pointer;
}

.checkbox-text {
  font-weight: 500;
  color: #333;
  font-size: 0.9rem;
}

.checkbox-label.required {
  border-color: #0D3B66;
  background: rgba(13, 59, 102, 0.05);
}

/* Error States */
.error-message {
  color: #dc3545;
  font-size: 0.8rem;
  margin-top: 4px;
}

/* Modal Footer */
.modal-footer {
  padding: 20px 24px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
}

/* Buttons - Now using global styles from design-system.css */

/* Responsive Design */
@media (min-width: 768px) {
  .form-row {
    grid-template-columns: 1fr 1fr;
  }

  .form-row:first-child {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .modal-overlay {
    padding: 10px;
  }

  .modal-container {
    max-height: 95vh;
  }

  .modal-header {
    padding: 16px 20px;
  }

  .modal-header h2 {
    font-size: 1.3rem;
  }

  .modal-body {
    padding: 20px;
  }

  .modal-footer {
    padding: 16px 20px;
    flex-direction: column;
  }

  .btn {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .modal-header {
    padding: 12px 16px;
  }

  .modal-body {
    padding: 16px;
  }

  .modal-footer {
    padding: 12px 16px;
  }

  .form-section {
    margin-bottom: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/applications/ApplicationForm.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF,mEAAmE;;AAEnE,qEAAqE;;AAErE,kEAAkE;;AAElE,+EAA+E;;AAE/E,gEAAgE;;AAEhE,mEAAmE;;AAEnE,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,cAAc;AACd;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB,iEAAiE;;AAEjE;;;EAGE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,wCAAwC;AAC1C;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,cAAc;AAChB;;AAEA,6DAA6D;;AAE7D,sBAAsB;AACtB;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/**\n * Application Form Styles\n * Clean, responsive styles matching UserCreateModal layout\n */\n\n/* Modal Overlay - Now using global styles from design-system.css */\n\n/* Modal Container - Now using global styles from design-system.css */\n\n/* Modal Header - Now using global styles from design-system.css */\n\n/* Close button - Now using global .modal-close styles from design-system.css */\n\n/* Modal Body - Now using global styles from design-system.css */\n\n/* Form Sections - Now using global styles from design-system.css */\n\n/* Committee Member Sections */\n.committee-member {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 1.5rem;\n  margin-bottom: 1.5rem;\n  border: 1px solid #e9ecef;\n}\n\n.committee-member:last-child {\n  margin-bottom: 0;\n}\n\n.committee-member h5 {\n  margin: 0 0 1rem 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #333;\n}\n\n/* Form Rows */\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.form-row:last-child {\n  margin-bottom: 0;\n}\n\n/* Form Groups */\n/* Form Groups - Now using global styles from design-system.css */\n\n.form-group input.error,\n.form-group select.error,\n.form-group textarea.error {\n  border-color: #dc3545;\n  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\n}\n\n.form-group input:disabled,\n.form-group select:disabled,\n.form-group textarea:disabled {\n  background: #f8f9fa;\n  color: #6c757d;\n  cursor: not-allowed;\n}\n\n/* Select Styling */\n.form-group select {\n  cursor: pointer;\n}\n\n/* Field Descriptions */\n.field-description {\n  color: #6c757d;\n  font-size: 0.875rem;\n  margin: 0.5rem 0 1rem 0;\n  line-height: 1.5;\n}\n\n.section-description {\n  color: #6c757d;\n  font-size: 0.9rem;\n  margin: 0 0 1rem 0;\n  line-height: 1.6;\n}\n\n/* Full Width Form Groups */\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n/* Screening Formats */\n.screening-formats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.format-option {\n  background: white;\n  border: 1px solid #e9ecef;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.format-option:hover {\n  border-color: #0D3B66;\n  box-shadow: 0 2px 4px rgba(13, 59, 102, 0.1);\n}\n\n.format-checkbox-label {\n  display: block;\n  cursor: pointer;\n  padding: 1rem;\n  margin: 0;\n}\n\n.format-checkbox-label input[type=\"checkbox\"] {\n  display: none;\n}\n\n.format-checkbox-content {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.format-checkbox-label input[type=\"checkbox\"]:checked+.format-checkbox-content {\n  background: rgba(13, 59, 102, 0.05);\n}\n\n.format-icon {\n  font-size: 1.25rem;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f8f9fa;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.format-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  flex: 1;\n}\n\n.format-name {\n  font-weight: 600;\n  color: #333;\n  font-size: 0.9rem;\n}\n\n.format-description {\n  color: #6c757d;\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n/* Settings Grid */\n.settings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 1.5rem;\n  margin-top: 1rem;\n}\n\n.setting-group {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 1.5rem;\n  border: 1px solid #e9ecef;\n}\n\n.setting-group h5 {\n  margin: 0 0 1rem 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #333;\n  padding-bottom: 0.5rem;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.setting-option {\n  margin-bottom: 1rem;\n}\n\n.setting-option:last-child {\n  margin-bottom: 0;\n}\n\n.setting-checkbox-label {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  cursor: pointer;\n  padding: 0.75rem;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  background: white;\n  border: 1px solid #e9ecef;\n}\n\n.setting-checkbox-label:hover {\n  background: #f8f9fa;\n  border-color: #0D3B66;\n}\n\n.setting-checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #0D3B66;\n  cursor: pointer;\n  margin-top: 0.25rem;\n  flex-shrink: 0;\n}\n\n.setting-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  flex: 1;\n}\n\n.setting-title {\n  font-weight: 600;\n  color: #333;\n  font-size: 0.9rem;\n}\n\n.setting-description {\n  color: #6c757d;\n  font-size: 0.8rem;\n  line-height: 1.4;\n}\n\n.setting-checkbox-label.required {\n  border-color: #0D3B66;\n  background: rgba(13, 59, 102, 0.05);\n}\n\n.terms-group {\n  grid-column: 1 / -1;\n  background: rgba(0, 123, 255, 0.05);\n  border: 2px solid rgba(0, 123, 255, 0.2);\n}\n\n/* Checkbox Groups */\n.checkbox-group {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  padding: 0.75rem;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  background: white;\n  border: 1px solid #e9ecef;\n}\n\n.checkbox-label:hover {\n  background: #f8f9fa;\n  border-color: #0D3B66;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  accent-color: #0D3B66;\n  cursor: pointer;\n}\n\n.checkbox-text {\n  font-weight: 500;\n  color: #333;\n  font-size: 0.9rem;\n}\n\n.checkbox-label.required {\n  border-color: #0D3B66;\n  background: rgba(13, 59, 102, 0.05);\n}\n\n/* Error States */\n.error-message {\n  color: #dc3545;\n  font-size: 0.8rem;\n  margin-top: 4px;\n}\n\n/* Modal Footer */\n.modal-footer {\n  padding: 20px 24px;\n  background: #f8f9fa;\n  border-top: 1px solid #e9ecef;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n/* Buttons - Now using global styles from design-system.css */\n\n/* Responsive Design */\n@media (min-width: 768px) {\n  .form-row {\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .form-row:first-child {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 767px) {\n  .modal-overlay {\n    padding: 10px;\n  }\n\n  .modal-container {\n    max-height: 95vh;\n  }\n\n  .modal-header {\n    padding: 16px 20px;\n  }\n\n  .modal-header h2 {\n    font-size: 1.3rem;\n  }\n\n  .modal-body {\n    padding: 20px;\n  }\n\n  .modal-footer {\n    padding: 16px 20px;\n    flex-direction: column;\n  }\n\n  .btn {\n    width: 100%;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-header {\n    padding: 12px 16px;\n  }\n\n  .modal-body {\n    padding: 16px;\n  }\n\n  .modal-footer {\n    padding: 12px 16px;\n  }\n\n  .form-section {\n    margin-bottom: 20px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
